module.exports = __webpack_public_path__ + "static/media/carrocompra.fc26c014.svg";